import * as $ from "jquery";
import Spinner from "../spinner";
import axios from "axios";
import {enableFormBack, handleValidationErrors} from "../forms";
import {toastAlert} from "../toastAlert";

export const profile_page = () => {
    $("#editStamp").on('file_submit', async function(e, {callback}) {
        let spinner = new Spinner();
        try {
            let response = await axios.post($(this).attr('action'), $(this).serialize());
            if (response.data.code !== 200) {
                if (response.data.errors) {
                    handleValidationErrors(response.data.errors, $(this));
                    enableFormBack(this);
                    spinner.destroy();
                    toastAlert('Wystąpił błąd podczas aktualizacji pieczątki.', {type: 'danger'})
                }

                return;
            }

            toastAlert('Pomyślnie zaktualizowano pieczątkę.', {type: 'success'})

            let form = $("#editStampModal form");
            callback();
            enableFormBack(this);

            let img = form.find('img');
            if($("#editStampModal input[data-id]").length > 0) {
                img.attr('src', img.attr('src') + '?t=' + new Date().getTime());
                img.closest('.col-12').show();
            } else {
                img.closest('.col-12').hide();
            }

            spinner.destroy();
        } catch (err) {
            spinner.destroy();
            toastAlert('Wystąpił błąd podczas aktualizacji pieczątki.', {type: 'danger'})
        }
    })

    $("#editStampModal form").on('file_delete', function(e, file) {
        file.to_delete = true;

        $(this).find('input[data-id][data-type="to_delete"]').val('true')
        $(this).find('img').closest('.col-12').hide();
    })

    // financial obligations table
    const financialObligationsTable = $('[data-app-financial_obligations="table"]');
    if(financialObligationsTable.length) {
        financialObligationsTable.DataTable({
            filters: {
                columns: [
                    {
                        index: 0,
                        title: 'Status',
                        values: [
                            {
                                text: 'nie zapłacono',
                                value: 1,
                                custom: (settings, searchData, index, rowData) => {
                                    return parseInt(rowData[0]['@data-order']) === 1;
                                }
                            },
                            {
                                text: 'zapłacono',
                                value: 2,
                                custom: (settings, searchData, index, rowData) => {
                                    return parseInt(rowData[0]['@data-order']) === 2;
                                }
                            }
                        ]
                    },
                ]
            }
        }).api();
    }
}
